import { render, staticRenderFns } from "./AbnormalPlayerConf.vue?vue&type=template&id=3a05aed5&scoped=true"
import script from "./AbnormalPlayerConf.vue?vue&type=script&lang=js"
export * from "./AbnormalPlayerConf.vue?vue&type=script&lang=js"
import style0 from "./AbnormalPlayerConf.vue?vue&type=style&index=0&id=3a05aed5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05aed5",
  null
  
)

export default component.exports